import { ButtonWithIcon } from '../buttons/buttonWithIcon';

const generateBucketPolicyUrl = (region: string, bucketName: string) => {
  return `https://${region}.console.aws.amazon.com/s3/bucket/${bucketName}/property/policy/edit?region=${region}&bucketType=general`;
};

export const VaultOwnBucketEditKeyPolicyButton = ({
  bucketName,
  region,
}: {
  bucketName: string;
  region: string;
}) => {
  return (
    <ButtonWithIcon
      variant='contained'
      disabled={!bucketName}
      text='Edit Bucket Policy in AWS'
      icon='material-symbols-open-in-new'
      iconPosition='right'
      onClick={() =>
        window.open(generateBucketPolicyUrl(region, bucketName), '_blank')
      }
    />
  );
};
